// tslint:disable
export enum CampaignStreamType {
    /**
     * @description UNKNOWN
     */
    UNKN = 10001,
    /**
     * @description INTERVAL
     */
    INT = 10002,
    /**
     * @description EVENT
     */
    EVT = 10003,
}
